module.exports = function requiredIf(type, condition) {
  return function(props) {
    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-required-if/index.js
 ** module id = 533
 ** module chunks = 0
 **/